const IsniError = () => {
  return <div className="h-2.5 w-2.5 rounded-full bg-red-500 mr-2" />;
};

export default IsniError;
